import React from "react";
import { GlobalContext } from "../../store/GlobalContext";
import useAlerta from "../hooks/useAlerta";

const Alerta = () => {
  const { msgAlerta } = React.useContext(GlobalContext);
  const { fechaAlerta } = useAlerta();

  return (
    <div id="alerta" className={msgAlerta ? "aberto" : ""}>
      <div className="msg">{msgAlerta}</div>
      <div className="act">
        <a onClick={() => fechaAlerta()}>OK</a>
      </div>
    </div>
  );
};

export default Alerta;
